// extracted by mini-css-extract-plugin
module.exports = {"container":"FuwfFooter_container__36bTT","row":"FuwfFooter_row__16_cX","number":"FuwfFooter_number__2c4Pt","delete":"FuwfFooter_delete__155pa","button":"FuwfFooter_button__3gzvf"};